/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import { getGiveaways } from "../../../../features/cms/cmsSlice";
import FormTitle from "../../../FormTitle/FormTitle";
import styles from "./ByGiveaway.module.scss";
import { CMS_ASSET_URL_BASE } from "../../../../config";
import { adobeClickTracking } from "../../../../helpers/tracking";

const ByGiveawayLanding = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state?.singleGroup);
  const giveaways = useSelector(getGiveaways);
  const gamesType = type === "single" ? "Single Game" : "Group";
  const prop13 = `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: By Giveaway/Promotion`;

  const giveawayBox = (giveaway) => (
    <>
      <div className={styles.left}>
        <img
          src={`${CMS_ASSET_URL_BASE}${giveaway.image_landing?.path}`}
          alt=" "
          className={styles.img}
        />
      </div>
      <div className={styles.right}>
        <div className={styles.name}>
          <h3>
            {giveaway?.name}
            <svg
              width="13"
              height="13"
              xmlns="http://www.w3.org/2000/svg"
              className={styles.arrow}
            >
              <path d="m4.274 12.25-1.332-1.325 4.605-4.6-4.776-4.75L4.103.25l6.127 6.076-5.956 5.924Z" />
            </svg>
          </h3>
        </div>
        <div className={styles.desc}>
          <p>{giveaway?.desc}</p>
        </div>
        <span className={styles.border}></span>
      </div>
    </>
  );
  useEffect(() => {
    if (!type) history.push("/");
  }, [giveaways, history, type]);
  //

  return (
    <div className={styles.body}>
      <FormTitle title="Select Giveaway or Promotion" />
      <div className={styles.boxes}>
        {giveaways &&
          giveaways.map((giveaway) => (
            <div
              className={styles.box}
              key={giveaway._id}
              onClick={() => {
                adobeClickTracking({
                  prop13,
                  prop14: `${gamesType} Tickets: By Giveaway/Promotion: ${giveaway.name} Click`,
                });
                history.push("/ticket-single-group/by-giveaway", {
                  data: giveaway.name,
                });
              }}
            >
              {giveawayBox(giveaway)}
            </div>
          ))}
      </div>
      <FormController
        backTo="/ticket-single-group"
        startOver="/"
        showBack
        showStartOver
      />
    </div>
  );
};

export default ByGiveawayLanding;
